<div class="mt-4">
  <label class="mt-1">Components</label>
</div>

@if (hasUserComponents) {
  <template-attribute-components
    isUserComponents="true"
  ></template-attribute-components>
} @else if (showEmptyState) {
  <div
    class="tw-flex tw-flex-col tw-items-center tw-rounded-lg tw-border tw-border-dashed tw-border-gray-300 tw-px-6 tw-py-12 tw-text-center"
  >
    <img
      src="../images/empty-layers.png"
      alt=""
      class="tw-mb-8 tw-h-auto tw-w-64"
    />
    <h3 class="tw-m-0 tw-text-2xl tw-font-bold tw-text-gray-900">
      You have no layers
    </h3>
    <p class="tw-mb-8 tw-mt-3 tw-text-xl tw-text-gray-700">
      Try adding some components like text and images to your canvas to make
      something interesting!
    </p>
    <button
      type="button"
      id="addComponentEmptyState"
      class="template-attribute-list__primary-button tw-flex tw-h-14 tw-w-full tw-items-center tw-justify-center tw-gap-2 tw-rounded-md tw-border-0 tw-text-xl tw-font-bold"
      (click)="showUserComponentSelector()"
    >
      <mat-icon
        aria-hidden="true"
        svgIcon="add"
        class="tw-h-6 tw-w-6"
      ></mat-icon>
      Add a component
    </button>
  </div>
}

@if (hasBaseComponents) {
  <div class="mt-4">
    <div class="flex-row">
      <label class="mt-1">Base Components</label>
      <mat-icon
        tabindex="0"
        aria-label="Base components help"
        matTooltip="Base components are part of the template and can not be moved or deleted, only hidden."
        matTooltipPosition="right"
        matTooltipClass="menu-tooltip"
        svgIcon="info-filled"
        class="small tw-text-blue-600 ml-2"
      ></mat-icon>
    </div>
  </div>
}

<template-attribute-components></template-attribute-components>
